import { render, staticRenderFns } from "./ra-simple-dialog.vue?vue&type=template&id=cc517184&scoped=true"
import script from "./ra-simple-dialog.vue?vue&type=script&lang=js"
export * from "./ra-simple-dialog.vue?vue&type=script&lang=js"
import style0 from "./ra-simple-dialog.vue?vue&type=style&index=0&id=cc517184&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc517184",
  null
  
)

export default component.exports